import { render, staticRenderFns } from "./skillTest.vue?vue&type=template&id=b270912c&scoped=true&"
import script from "./skillTest.vue?vue&type=script&lang=js&"
export * from "./skillTest.vue?vue&type=script&lang=js&"
import style0 from "./skillTest.vue?vue&type=style&index=0&id=b270912c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b270912c",
  null
  
)

export default component.exports